export function normalizeRadian(radian: number) {
  const twoPi = Math.PI * 2;
  const _radian = ((radian % twoPi) + twoPi) % twoPi;
  return Number(_radian.toFixed(3))
}